module.exports = __webpack_public_path__ + "d308073b/img/SOURCERY_poweredby_web.9819842b.png";